import Routes from "@/routes/routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import moment from 'moment'; // Importa o módulo Moment.js
import 'moment/dist/locale/pt-br';
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { OfflineIndicator } from "./components/OfflineIndicator";
import { SWCacheManager } from "./components/SWCacheManager";
import { ApiStatusProvider } from "./context/ApiStatusProvider";
import { AuthProvider } from "./context/AuthProvider";
import { NotificationProvider } from "./context/NotificationProvider";
import { OnboardingProvider } from "./context/OnboardingContext";

// Criar QueryClient fora do componente para evitar recriação
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: 1,
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
      refetchOnReconnect: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

moment.locale("pt-br");
console.log("Locale configurado:", moment.locale()); // Verificar se o locale foi aplicado

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <OnboardingProvider>
          <AuthProvider>
            <ApiStatusProvider>
              <NotificationProvider>
                <main className="bg-white max-w-7xl lg:max-w-lg mx-auto min-h-svh">
                  <Routes />
                </main>
              </NotificationProvider>
            </ApiStatusProvider>
          </AuthProvider>
          {/* <PWAInstallPrompt /> */}
        </OnboardingProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      <OfflineIndicator />
      <SWCacheManager />
    </QueryClientProvider>
  );
}
